<template>
<div class="container">
  <div class="row" style="height: 100%; padding-bottom: 10%;">
    <div class="col">

      <b-row style="width: 100%; justify-content: center; margin: 20px 10px 0 0">
        <h2>Área de administrador</h2>
      </b-row>

      <b-row style="justify-content: left; margin: 10px">
        <h4>Usuários cadastrados</h4>
      </b-row>

      <b-row>
        <b-col md="3" style="margin-bottom: 12px; padding-left: 10px; padding-right: 35px;">
          <input class="form-control" placeholder="Pesquisar usuário por nome" @keyup="searchUser" v-model="searchedUserName"/>
        </b-col>
        <b-col md="3" >
          <b-btn class="add-user-btn" variant="outline-success" @click="selectedUser = null">Adicionar Usuário</b-btn>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" style="overflow-y: scroll; height: 400px;">
            <div class="card" v-for="user in displayUsers" :key="user.id">
              
                <div class="card-body">
                  <a type="button" @click="selectedUser = user">
                    {{user.name}} 
                  </a>
                  
                  <a type="button" @click="openDeleteUserConfirmationModal(user)" class="float-right" >
                    <img class="icon" :src="deleteIcon" alt="edit"/>
                  </a>
                  
                </div>
              
            </div>
        </b-col>

        <b-col md="3">
          <b-card>
            <b-card-header>
              Dados de usuário
            </b-card-header>
            <b-card-body>
              <user-form :readonly="false" :user="selectedUser" @userEvent="listUsers"/>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col md="5">
          <b-card>
            <b-card-header>
              Dados de terapeuta 
            </b-card-header>
            <b-card-body>
              <therapist-form v-if="selectedUser && selectedUser.therapist" :therapistId="selectedUser.therapist.id"/>
            </b-card-body>
          </b-card>
        </b-col>

      </b-row>
       
    </div>

    <b-modal v-if="selectedUser"
      :id="deleteUserModal" 
      :title="`Deletar usuário ${selectedUser.name}`"
      @ok="deleteUserAsync"
      ok-variant="danger"
      ok-title="Deletar"
      cancel-title="Cancelar"
    >
      <p class="my-4">
        Tem certeza que deseja deletar o usuário <strong>{{ selectedUser.name }}</strong> da base de dados?
      </p>
      </b-modal>

  </div>
</div>
</template>

<script>
import UserForm from '../components/UserForm.vue'
import TherapistForm from '../components/TherapistForm.vue'

import * as usersApiClient from '../js/usersApiClient'
import pencilIcon from '../assets/images/pencil.svg'
import deleteIcon from '../assets/images/icons8-delete.svg'
import Vue from "vue";

export default {
  components: { 
    UserForm,
    TherapistForm
  },
  name: 'Admin',
  data() {
    return {
      users: [],
      searchedUserName: '',
      displayUsers: [],
      selectedUser: null,
      pencilIcon,
      deleteIcon
    }
  },
  async mounted() {
    await this.listUsers();
  },
  methods: {
    async listUsers() {
      this.selectedUser = null;
      
      const listUsersResponse = await usersApiClient.listUsersAsync();
      
      if (!listUsersResponse.success) {
        Vue.$toast.error(`Erro ao listar usuários. Motivo: ${listUsersResponse.errors[0]?.description}`)
        return
      }
      
      const users = listUsersResponse.data;
      
      this.users = users.sort((a,b) => a.name.localeCompare(b.name));
      this.displayUsers = users;
    },
    async deleteUserAsync() {
      await usersApiClient.deleteUserAsync(this.selectedUser.id);
      
      await this.listUsers();
      this.selectedUser = null;
    },
    openDeleteUserConfirmationModal(user) {
      this.selectedUser = user;
      this.$bvModal.show(this.deleteUserModal);
    },
    searchUser() {
      this.displayUsers = this.searchedUserName ? this.users
        .filter(u => u.name.toLowerCase().includes(this.searchedUserName.toLowerCase())) 
        : this.users;
    }
  },
  computed: {
    deleteUserModal: () => 'delete-user-modal',
  }
}
</script>

<style scoped>

.icon {
  width: auto;
  height: 20px;
  margin-right: 0px;
  margin-left: 20px;
}

.float-right {
  float: right;
}

.add-user-btn {
  background-color: #3EAF7C;
  color: white;
}

.add-user-btn:hover {
  background-color: white;
  color: #3EAF7C;
}


</style>
